import { config, zh_CN } from '@kaokei/md-editor-v3';
import { IMG_CDN, PUBLIC_CDN } from '~/utils/environment';
import { isConsumerEditor } from './editor-config';
import { markdownItInputOutput } from './markdown-it-input-output';
import { markdownItThirdPartyCode } from './markdown-it-third-party-code';
import { markdownItThirdPartyImage } from './markdown-it-third-party-image';
import { markdownItThirdPartyLink } from './markdown-it-third-party-link';
import { markdownItToConsumer } from './markdown-it-to-consumer';
import { getMarkdownOptions } from './markdown-manager';
import { showErrorMsg } from '#imports';

function initMarkdownEditorConfig() {
  zh_CN.copyCode = {
    text: '复制',
    successTips: '复制成功',
    failTips: '复制失败',
  };

  config({
    editorExtensions: {
      highlight: {
        js: `${PUBLIC_CDN}/fe/highlightjs-cdn-assets/11.11.1/highlight.min.js`,
      },
      prettier: {
        standaloneJs: `${PUBLIC_CDN}/fe/prettier/3.5.3/standalone.js`,
        parserMarkdownJs: `${PUBLIC_CDN}/fe/prettier/3.5.3/plugins/markdown.js`,
      },
      cropper: {
        js: `${PUBLIC_CDN}/fe/cropperjs/1.6.2/dist/cropper.min.js`,
        css: `${PUBLIC_CDN}/fe/cropperjs/1.6.2/dist/cropper.min.css`,
      },
      screenfull: {
        js: `${PUBLIC_CDN}/fe/screenfull/5.2.0/dist/screenfull.js`,
      },
      mermaid: {
        js: `${PUBLIC_CDN}/fe/mermaid/11.6.0/dist/mermaid.min.js`,
      },
      katex: {
        js: [
          `${PUBLIC_CDN}/fe/katex/0.16.22/dist/katex.min.js`,
          `${IMG_CDN}/htoj/fe/katex/0.16.22/dist/katex.min.js`,
        ] as unknown as string,
        css: [
          `${PUBLIC_CDN}/fe/katex/0.16.22/dist/katex.min.css`,
          `${IMG_CDN}/htoj/fe/katex/0.16.22/dist/katex.min.css`,
        ] as unknown as string,
      },
    },
    editorExtensionsAttrs: {
      katex: {
        js: {
          onerror: function () {
            document.body.classList.add('katex-load-error');
            window.__bl.error({ name: 'KatexLoadError' });
            showErrorMsg('网络异常导致数学表达式渲染异常，请刷新页面重试！');
          },
        },
      },
    },
    markdownItConfig(md, { editorId }) {
      // 强制关联来自编辑器的配置项
      // 相关配置项可以直接影响到markdown的渲染结果
      // 目前的配置项都是静态的，也就是不会发生变化从而再次影响markdown的渲染结果
      (md.options as any).editor = getMarkdownOptions(editorId) || {};
    },
    markdownItPlugins(plugins, { editorId }) {
      const customPlugins = [] as any[];
      const options = getMarkdownOptions(editorId) || {};
      if (isConsumerEditor(options.type)) {
        customPlugins.push({
          type: 'markdownItThirdPartyCode',
          plugin: markdownItThirdPartyCode,
        });
        customPlugins.push({
          type: 'markdownItThirdPartyLink',
          plugin: markdownItThirdPartyLink,
        });
        customPlugins.push({
          type: 'markdownItThirdPartyImage',
          plugin: markdownItThirdPartyImage,
        });
        customPlugins.push({
          type: 'markdownItToConsumer',
          plugin: markdownItToConsumer,
          options: editorId,
        });
      } else {
        customPlugins.push({
          type: 'markdownItThirdPartyCode',
          plugin: markdownItThirdPartyCode,
        });
        customPlugins.push({
          type: 'markdownItInputOutput',
          plugin: markdownItInputOutput,
        });
      }
      return [...plugins, ...customPlugins];
    },
  });
}

initMarkdownEditorConfig();
